import React from 'react';
import VehicleDetails from './components/VehicleDetails';
import VehicleRentalCard from './components/VehicleRentalCard';
import Similer from './components/Similer';
import Gifts from './components/Gifts';
import SearchFor from './components/SearchFor';
import Faq from './components/Faq';
import RentalInputsProvider from '@app/context/rental/RentalInputsProvider';

const RentalResult = () => {
    return (
        <RentalInputsProvider>
            <div className="container">
                <VehicleDetails />
                <div className="row pt-3">
                    <div className="col-lg-8 vehicle-main">
                        <VehicleRentalCard />
                    </div>
                    <div className="col-lg-4 simler">
                        <Similer />
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-lg-12 py-5 gifts">
                        <Gifts />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 search pb-5">
                      <SearchFor/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <Faq/>
                    </div>
                </div>
            </div>
        </RentalInputsProvider>
    );
};

export default RentalResult;
